<template>
    <div class="cc-free-delivery" v-if="freeDelivery.condition && showFreeDelivery">
        <div class="cc-free-delivery__header">
            <div class="cc-free-delivery__title" v-if="freeDelivery.remaining > 0">{{ translations['Buy for at least'] }} <span class="cc-free-delivery__condition">{{ this.freeDelivery.formatted.remaining }}</span> {{ translations['and you get'] }} <span class="cc-free-delivery__benefit">{{ translations['free delivery'] }}!</span></div>
            <div class="cc-free-delivery__title" v-else>{{ translations['You got free delivery'] }}!</div>
        </div>
        <div class="cc-free-delivery__main">
            <div class="cc-free-delivery__progressbar">
                <div class="cc-free-delivery__progress" :style="{width: this.freeDelivery.formatted.percent}"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        computed: {
            ...mapState({
                translations: state => state.translations,
                freeDelivery: state => state.freeDelivery,
                showFreeDelivery: state => state.config.show_free_delivery
            }),
        },
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/components/free-delivery";
</style>
